export default __webpack_public_path__ + "static/media/0-2.22c42256.png";